<div class="grid-container  padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">User Recertification</legend>
  </div>
  <div class="grid-row grid-gap">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 usa-form">
      <label for="country" class="usa-label">User Type<abbr title="required"
      class="usa-hint usa-hint--required">*</abbr></label>
      <select id="userType" class="usa-select" title="user_type" name="selectedValue" [(ngModel)]="selectedValue" (change)="onSelectUserType($event)">

        @for (userType of typeOfUser; track userType) {
          <option [ngValue]="userType">{{userType}}</option>
        }
      </select>
    </div>
  </div>

  <div class="grid-row grid-gap  padding-y-2">
    <ag-grid-angular class="ag-theme-alpine"
      style="width: 100%; height: 100%;"
      [rowData]="data"
      [pagination]="true"
      [masterDetail]="true"
      [columnDefs]="userColDef"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (rowSelected)="onSelectionChanged($event)">
    </ag-grid-angular>
    <div>
      <ul class="usa-button-group">
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="onRecertifyUser()" [disabled]="this.isDisabled">Recertify</button>
        </li>
        <li class="usa-button-group__item">
          <button type="button" class="usa-button usa-button--secondary usa-button--active" (click)="onDeleteUser()" [disabled]="this.isDisabled">Delete</button>
        </li>
      </ul>
    </div>

  </div>
</div>